export default __webpack_public_path__ + "static/media/ChaltenUso40.be25db36.jpeg";